<template>
<div v-if="state.initDone">
  <TopMenu />
  <HelpSidebar />
  <div class="container" id="main-container">
    <b-form @submit="search" @reset="reset" inline>
      <div class="row mx-auto flex-column" v-if="state.groups !== null && state.groups.length > 0 && !state.admin">
        <b-form-checkbox class="mb-2" v-model="searchForm.searchOnlyInUserGroups" id="search-in-your-groups">
          <strong>Search only in your programs ({{state.groups.join(', ')}})</strong>
        </b-form-checkbox>
      </div>
      <Form id="main-form" />
    </b-form>
    <div class="clearfix mb-4 mt-3">
      <b-button @click="reset" class="float-right ml-2">Reset</b-button>
      <b-button variant="primary" @click="search" class="float-right" id="search-btn">Search</b-button>
      <p class="text-danger float-right mr-3 mt-1" v-if="formHasErrors">There are some errors in the form fields</p>
    </div>
    <ResultTable />
    <p class="text-center mt-4">
      <em>
        If you have used IA2 facilities for your research, please include in papers or presentations the following acknowledgment:<br />
        "This research used the facilities of the Italian Center for Astronomical Archive (IA2) operated by INAF at the Astronomical Observatory of Trieste."
      </em>
    </p>
    <p class="text-center mt-3">
      <a href="#" v-b-modal.modal-privacy-policy @click.prevent>Privacy policy</a>
    </p>
    <b-modal size="lg" id="modal-privacy-policy" title="Privacy policy" ok-only>
      <div class="row">
        <div class="col">
          <p>In accordance with the <a href="http://www.garanteprivacy.it/web/guest/home/docweb/-/docweb-display/docweb/4814258" target="_blank">Italian Personal Data Protection Code - Legislative Decree no. 196 of 30 June 2003</a>
            and the guidelines contained in the <a href="http://ec.europa.eu/justice/data-protection/article-29/documentation/opinion-recommendation/files/2001/wp43_en.pdf" target="_blank">European Recommendation no. 2/2001</a>,
            which was adopted on 17 May 2001 by the European data protection authorities,
            we inform our users that this web site uses cookies and analogous systems.
          </p>
          <p>These cookies don't contain user personal data and are used only to store temporary values, like the session identifier, or user preferences, so they can be considered "technical cookies".</p>
          <p>We don't use third parties cookies.</p>
        </div>
      </div>
    </b-modal>
  </div>

  <footer class="text-center" id="site-footer">
    Powered by <img src="@/assets/images/logo_ia2.png" alt="logo IA2" />
    <a href="https://www.ia2.inaf.it/" target="_blank"><strong class="text-primary">IA2</strong></a>
  </footer>
</div>
</template>

<script>
import client from 'api-client';
import TopMenu from './TopMenu.vue';
import Form from 'Form';
import ResultTable from './ResultTable.vue';
import HelpSidebar from './HelpSidebar.vue';
import {
  mapState
} from 'vuex';

export default {
  name: 'MainPage',
  computed: mapState({
    state: state => state,
    searchForm: state => state.searchForm,
    formHasErrors: state => Object.keys(state.searchForm.fieldErrors).length > 0
  }),
  components: {
    TopMenu,
    Form,
    ResultTable,
    HelpSidebar
  },
  created() {
    client.init()
      .then(initModel => this.$store.dispatch('init', initModel));
  },
  methods: {
    search() {
      this.$store.dispatch("search");
    },
    reset() {
      this.$store.commit("reset");
      this.$root.$emit('resetFields');
    }
  }
}
</script>

<style>
.vdatetime-input {
  width: 100% !important;
}

#main-form {
  width: 100%;
}

#main-form label {
  font-weight: bold;
}

#main-form .custom-radio label {
  font-weight: normal;
}

.form-part>.row {
  margin-top: 10px;
  margin-bottom: 10px;
}

#main-form .fit-width {
  width: 100%;
}

#main-form .label-left label {
  justify-content: left;
}

#main-form .label-right label {
  justify-content: right;
}

a.nav-link {
  outline: 0;
}

body {
  background-position: bottom center;
  background-attachment: fixed;
  background-repeat: repeat-x;
  margin-top: 60px;
}

#main-container {
  /* we don't want responsiveness here */
  min-width: 1140px;
  padding-top: 15px;
}

#site-footer {
  color: #666;
  border-top: 1px #e7e7e7 solid;
  background-color: #f8f8f8;
  padding: 5px 0;
  margin-top: 30px;
}
</style>
